/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import { AccountCircle, VerifiedUser } from '@mui/icons-material';
import { Avatar, Menu, MenuItem, Typography } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import { stringToColor, stringAvatar } from 'utils/stringAvatar';

export type TUserAvatarProps = {
	user: string;
	size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | undefined;
	onClick: (e: SyntheticEvent) => void;
};
export const UserAvatar: FC<TUserAvatarProps> = ({ user, onClick, size = 'sm' }) => {
	const newUserNameLC = user?.split?.(' ')?.[0]?.toLowerCase();
	const newUserNameUc = `${newUserNameLC?.[0]?.toUpperCase()}${newUserNameLC?.slice(1)}`;
	const newUserName = user === 'Unknown user' || !user ? '' : newUserNameUc;
	const handleOnClick = (e: SyntheticEvent) => {
		console.log('handleOnClick');
		onClick(e);
		// e.stopPropagation();
	};

	console.log('newUserName', newUserName);
	console.log('user', user);

	return (
		<Typography
			// ref={refnewUserNameFilter}
			component="button"
			sx={{
				fontWeight: 'bold',
				// color: 'primary.main',
				// color: '#fff',
				color: '#00000080',
				fontSize:
					size === 'xxs'
						? '.6rem'
						: size === 'xs'
							? '.7rem'
							: size === 'sm'
								? '0.9rem'
								: size === 'md'
									? 20
									: 48,
				display: 'flex',
				alignItems: 'center',
				gap: '3px',
				cursor: 'pointer',
				// border: '1px solid gray',
				borderRadius: '20px',
				padding: '3px 8px 3px 3px',
				// borderColor: 'primary.main',
				backgroundColor: newUserName === '' ? '#c5c5c5' : stringToColor(newUserName),
				border: 0,
			}}
			onClick={(e: SyntheticEvent) => {
				handleOnClick(e);
			}}
		>
			{newUserName ? (
				<Avatar
					{...stringAvatar(newUserName ?? '', size)}
					src={
						newUserName === 'Rostislav'
							? '/img/users/ros.png'
							: newUserName === 'Aleksandra'
								? '/img/users/alex.png'
								: newUserName === 'Mikhail'
									? '/img/users/mikh.png'
									: newUserName === 'Peter'
										? '/img/users/peter.png'
										: newUserName === 'Teemu'
											? '/img/users/teemu.png'
											: newUserName === 'Robert'
												? '/img/users/robert.png'
												: newUserName === 'Nikolai'
													? '/img/users/nick.png'
													: newUserName === 'Andrii'
														? '/img/users/andrii.png'
														: newUserName === 'Victoria'
															? '/img/users/victoria.png'
															: newUserName === 'Oleg'
																? '/img/users/oleg1.jpg'
																: newUserName === 'Sasha'
																	? '/img/users/sasha.png'
																	: newUserName === 'Shirin'
																		? '/img/users/shirin.png'
																		: undefined
					}
				/>
			) : (
				<AccountCircle
					sx={{
						fontSize:
							size === 'xxs'
								? '1.2rem'
								: size === 'xs'
									? '1.4rem'
									: size === 'sm'
										? '1.8rem'
										: size === 'md'
											? 20
											: 48,
					}}
				/>
			)}

			{newUserName === '' ? 'Unknown' : newUserName}
		</Typography>
	);
};
